import Backbone from 'backbone';
import React from 'react';

import {Permissions} from 'auth/PermissionConstants';
import * as NavConstants from 'constants/NavConstants';
import ExportActions from 'exports/ExportActions';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import BasicInformationPanelView from 'toolbar/shared/BasicInformationPanelView';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as WorkflowActions from 'workflows/WorkflowActions';

import * as StageEntryActions from './StageEntryActions';
import StageEntryFile from './StageEntryFile';

export default class StageEntryInformationPanelView extends BasicInformationPanelView<StageEntryFile> {
  override initialize(options?: Backbone.ViewOptions<StageEntryFile> | undefined): void {
    super.initialize(options);
    this.requestExport = this.requestExport.bind(this);
  }

  handleOpenWorkflow(): void {
    SidepanelActions.openSection(NavConstants.SECTIONS.WORKFLOWS);
    // @ts-expect-error: should replace `this.model.get('stageEntryDocument')` -> `this.model.proxied()` for proper types
    WorkflowActions.openWorkflowDetailsScreen(this.model.get('stageEntryDocument').workflowId);
  }

  // TODO(T12654): Remove
  override getPermissions(): Permissions {
    const permissions = super.getPermissions();
    const review = this.model.review();
    const writable = permissions.writable && Boolean(!review || permissions.canSendForReview);
    return {...permissions, writable};
  }

  getAdditionalPanelContent(): JSX.Element {
    return (
      <Row>
        <Col md={12}>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            fullWidth={true}
            onClick={this.handleOpenWorkflow.bind(this)}
            size={ButtonSize.SMALL}
            text="Open workflow"
          />
        </Col>
      </Row>
    );
  }

  isDeleteEnabled(): boolean {
    return false;
  }

  saveChangesToModel(name: string): void {
    StageEntryActions.saveFileData(this.model.id, name, {success: this.onSaveSuccess});
  }

  requestExport(): void {
    ExportActions.requestExportFile(this.model.id);
  }
}
